export { default as MeetingNote } from './page'


// WEBPACK FOOTER //
// ./src/pages/MeetingNote/index.js